// extracted by mini-css-extract-plugin
module.exports = {"container":"embedded-video-module--container--37j9T"};